module.exports = __webpack_public_path__ + "img/abs015.a3d84832.svg";